/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { WoundMeasurementViewModel } from './WoundMeasurementViewModel'; 

export function getWoundAssessmentMeasurementOptions(woundAssessmentId: string, onSuccess?: (result?: WoundMeasurementViewModel) => void) {
	return queryOptions({
		queryKey: ['wound-assessment-measurement', woundAssessmentId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/woundmanagement/queries/getwoundassessmentmeasurement/' + woundAssessmentId;
			const resp = await axios.get<WoundMeasurementViewModel | null>(url);
	        const result = resp.data ?? null;
	        onSuccess?.(result ?? undefined);
	        return result;
        },
        select: (x) => x ?? undefined,
        enabled: Boolean(woundAssessmentId)
	});
}